var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',[_c('center',[_c('v-img',{attrs:{"src":"https://sellary.app/wp-content/uploads/2021/09/404_cat-768x768.png","height":"400","width":"400"}}),_c('h2',[_vm._v("Sorry the requested page was not found.")]),_c('br'),_c('v-btn',{attrs:{"depressed":"","color":"primary","to":"/"}},[_vm._v("Home")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }